import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Seo from "../components/Seo";


const Career = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <Seo
        title="Career Opportunities at Mortbuzz - Join Our Team"
        description="Explore exciting career opportunities at Mortbuzz. Join our dynamic team in the financial services industry and grow your career with us."
        keywords="Mortbuzz careers, job openings, financial services jobs, loan advisor jobs, work at Mortbuzz, banking jobs"
        canonical="https://www.mortbuzz.in/Career"
      />

    

      {/* HERO */}
      <section
        className="careerhero d-flex align-items-center border-bottom border-primary"
        style={{
          background: `url('/images/FrontPage/a-high-fashion-portrait-of-a-young-india_BWxDzL3KT5qVpNrYtabBcw_ag3iocdtR4WNluywrW8oIw.jpeg') center/cover no-repeat fixed`,
          color: '#000',
          padding: '6rem 0',
          position: 'relative',
        }}
      >
        <div
          className="overlay"
          style={{
            background: 'rgba(0, 0, 0, 0.65)',
            position: 'absolute',
            inset: 0,
            zIndex: 1,
          }}
        />
        <div className="container content text-center" style={{ position: 'relative', zIndex: 2 }}>
          <h1 className="display-4 fw-bold" data-aos="fade-down" style={{ color: '#1359e4' }}>
            Join Mortbuzz
          </h1>
          <p className="lead" data-aos="fade-up" data-aos-delay="200">
            As a Relationship Manager
          </p>
          <a
            href="https://forms.gle/Fivmt1YR8KRf4twc9"
            className="btn btn-lg mt-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            style={{ backgroundColor: 'blue', color: 'white', border: 'none' }}
          >
            <i className="fas fa-file-signature me-2"></i>Apply Now
          </a>
        </div>
      </section>

      {/* ABOUT COMPANY */}
      <section className="container py-5 bg-dark text-white">
        <h2 className="section-title" data-aos="fade-right" style={{ borderLeft: '5px solid #1359e4', paddingLeft: '1rem' }}>
          About Mortbuzz
        </h2>
        <p data-aos="fade-up">
          Welcome to <strong>Mortbuzz Solutions India Pvt. Ltd.</strong>, a trusted name in the financial services space,
          offering Home Loans, Balance Transfers (BT), and Loans Against Property (LAP). We're driven by the goal of
          empowering clients with transparent and personalized financial solutions.
        </p>
        <p data-aos="fade-up" data-aos-delay="100">
          Located in <strong>2nd Floor, Mahadik House, Bhosale Nagar, Hadapsar, Pune</strong>, we're expanding our dynamic
          team and looking for passionate Relationship Managers.
        </p>
      </section>

      {/* JOB DETAILS */}
      <section className="bg-dark text-white py-5 border-bottom border-primary">
        <div className="container">
          <h2 className="section-title" data-aos="fade-left" style={{ borderLeft: '5px solid #1359e4', paddingLeft: '1rem' }}>
            Job Description
          </h2>
          <ul className="list-unstyled fs-5" data-aos="fade-up">
            <li>
              <i className="fas fa-user-tie info-icon" style={{ color: '#1359e4', marginRight: '0.5rem' }}></i>
              <strong>Position:</strong> Relationship Manager
            </li>
            <li>
              <i className="fas fa-map-marker-alt info-icon" style={{ color: '#1359e4', marginRight: '0.5rem' }}></i>
              <strong>Location:</strong> Pune, Maharashtra
            </li>
            <li>
              <i className="fas fa-briefcase info-icon" style={{ color: '#1359e4', marginRight: '0.5rem' }}></i>
              <strong>Type:</strong> Full-time
            </li>
          </ul>
          <p className="mt-3" data-aos="fade-up" data-aos-delay="100">
            As a Relationship Manager, you’ll work with clients to recommend optimal loan solutions, focusing on loans up to
            ₹1 Crore. Your role is key in guiding applicants through application, approval, and disbursal while ensuring
            exceptional customer experience.
          </p>
        </div>
      </section>

      {/* RESPONSIBILITIES */}
      <section className="container py-5 bg-dark text-white border-bottom border-primary">
        <h2 className="section-title" data-aos="fade-right" style={{ borderLeft: '5px solid #1359e4', paddingLeft: '1rem' }}>
          Key Responsibilities
        </h2>
        <ul className="fs-5" data-aos="fade-up">
          <li>
            <i className="fas fa-handshake info-icon" style={{ color: '#1359e4', marginRight: '0.5rem' }}></i> Build lasting
            client relationships
          </li>
          <li>
            <i className="fas fa-coins info-icon" style={{ color: '#1359e4', marginRight: '0.5rem' }}></i> Advise on Home
            Loans, BT, LAP
          </li>
          <li>
            <i className="fas fa-file-alt info-icon" style={{ color: '#1359e4', marginRight: '0.5rem' }}></i> Assist with loan
            processing & documentation
          </li>
          <li>
            <i className="fas fa-smile info-icon" style={{ color: '#1359e4', marginRight: '0.5rem' }}></i> Ensure smooth client
            experience
          </li>
          <li>
            <i className="fas fa-chart-line info-icon" style={{ color: '#1359e4', marginRight: '0.5rem' }}></i> Track and
            report loan performance
          </li>
        </ul>
      </section>

      {/* QUALIFICATIONS & BENEFITS */}
      <section className="bg-dark text-white border-bottom border-primary py-5">
        <div className="container">
          <h2 className="section-title" data-aos="fade-left" style={{ borderLeft: '5px solid #1359e4', paddingLeft: '1rem' }}>
            Qualifications & Benefits
          </h2>
          <div className="row">
            <div className="col-md-6" data-aos="fade-right">
              <h5>
                <i className="fas fa-check-circle info-icon" style={{ color: '#1359e4', marginRight: '0.5rem' }}></i>
                Qualifications
              </h5>
              <ul className="fs-5">
                <li>Graduate in any stream (Finance preferred)</li>
                <li>Experience in loan sales or financial products</li>
                <li>Good communication & interpersonal skills</li>
              </ul>
            </div>
            <div className="col-md-6" data-aos="fade-left">
              <h5>
                <i className="fas fa-gift info-icon" style={{ color: '#1359e4', marginRight: '0.5rem' }}></i> Benefits
              </h5>
              <ul className="fs-5">
                <li>Competitive Salary + Incentives</li>
                <li>Health, Dental, Vision Insurance</li>
                <li>Performance bonuses on high-ticket loans</li>
                <li>Learning & development programs</li>
                <li>Office Hours: 9:30 AM – 6:30 PM</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* APPLICATION FORM */}
      <section className="container py-5 bg-dark text-white" id="apply">
        <h2 className="section-title text-center" data-aos="zoom-in" style={{ borderLeft: '5px solid #1359e4', paddingLeft: '1rem' }}>
          Ready to Join?
        </h2>
        <p className="text-center mb-4" data-aos="fade-up">
          Submit your resume or email us at <strong>contact@mortbuzz.in</strong>
        </p>
        <div className="row justify-content-center">
          <a href="https://forms.gle/Fivmt1YR8KRf4twc9" className="btn btn-primary w-100 tool-btn">
            Apply Form
          </a>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-dark text-white text-center py-4">
        <p>&copy; 2025 Mortbuzz Solutions India Pvt. Ltd. | Bhosale Nagar, Hadapsar, Pune</p>
      </footer>
    </>
  );
};

export default Career;
